import { Avatar as MaterialAvatar } from '@mui/material';
import { axiosPrivate } from 'modules/networkTools/networkTools';
import { useEffect, useState } from 'react';

type Props = {
  imageUrl: string | null;
};

const Avatar = ({ imageUrl }: Props) => {
  const [image, setImage] = useState<string>();

  useEffect(() => {
    if (imageUrl == null) {
      return;
    }
    (async () => {
      const url = `setup/organization/user/profile-image?key=${imageUrl}`;
      const response = await axiosPrivate.get(url, { responseType: 'blob' });

      setImage(URL.createObjectURL(response.data));
    })();
  }, []);

  return (
    <MaterialAvatar
      src={image}
      sx={{
        width: 16,
        height: 16
      }}
    />
  );
};

export default Avatar;
